/* unplugin-vue-components disabled */import { render } from "./dragcontent.vue?vue&type=template&id=5d13b496&scoped=true"
import script from "./dragcontent.vue?vue&type=script&lang=js"
export * from "./dragcontent.vue?vue&type=script&lang=js"

import "./dragcontent.vue?vue&type=style&index=0&id=5d13b496&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d13b496"]])

export default __exports__